var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-permission"},[_c('mu-title',{attrs:{"color":"primary"}},[_vm._v("Sem permissão de acesso")]),_c('p',[_vm._v("Você não tem permissão para acessar a essa página.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }